import { Component, computed, inject, input } from '@angular/core';
import { NodeProcon } from '@app/models/entity.model';
import { EntitySharedModule } from '@app/modules/entity.shared.module';
import { ProductHeroComponent } from '@app/components/product/product-hero/product-hero.component';
import { ParagraphLoaderComponent } from '@app/entities/paragraph/loader.component';

import { ContentLinkService } from '@app/services/contentLinks.service';

@Component({
  selector: 'mobi-node-procon',
  templateUrl: './node-procon.component.html',
  styleUrls: ['./node-procon.component.scss'],
  imports: [EntitySharedModule, ProductHeroComponent, ParagraphLoaderComponent],
  standalone: true,
})
export class NodeProconComponent {
  readonly entity = input.required<NodeProcon>();

  #contentLink = inject(ContentLinkService);

  contentLinks = computed(() => {
    const paragraphs = this.entity()?.paragraphs;
    return this.#contentLink.getContentLinks(paragraphs);
  });
}
